import type { Meta } from '@streamit/contracts';
import { Film, Play } from 'lucide-react';
import { safeImage } from '@/lib/catalog';
import { MediaRail } from './media-rail';
export function MediaRow({
  title,
  items,
  onSelect,
  rail,
}: {
  title: string;
  items: Meta[];
  onSelect: (m: Meta) => void;
  /** Render as a horizontally scrollable row; the key identifies its source. */
  rail?: { resetKey: string };
}) {
  const cards = items.slice(0, 60).map((m) => (
    <button
      className="poster-card"
      key={`${m.type}:${m.id}`}
      onClick={() => onSelect(m)}
    >
      <div className="poster-art" data-shape={m.posterShape}>
        {safeImage(m.poster) ? (
          <img
            src={safeImage(m.poster)}
            alt=""
            loading="lazy"
            decoding="async"
            referrerPolicy="no-referrer"
          />
        ) : (
          <Film size={35} />
        )}
        <span className="poster-play">
          <Play fill="currentColor" size={22} />
        </span>
        {m.imdbRating && <span className="rating">★ {m.imdbRating}</span>}
      </div>
      <strong>{m.name}</strong>
      <small>{m.releaseInfo || m.type}</small>
    </button>
  ));
  return (
    <section className="media-section">
      <div className="section-title">
        <h2>{title}</h2>
        <span>{items.length} titles</span>
      </div>
      {rail && items.length ? (
        <MediaRail label={title} resetKey={rail.resetKey}>{cards}</MediaRail>
      ) : (
        <div className="poster-grid">{cards}</div>
      )}
      {!items.length && <p className="muted">No titles found.</p>}
    </section>
  );
}
